export default __webpack_public_path__ + "static/media/vission.a11651e6.png";